var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useEntityLayout } from '../hooks/use-entity-layout';
import { camelCase, identity } from 'lodash';
import { useEntity } from '../hooks/use-entity';
import { platformQueryValue } from './platform-query-value';
import { usePageEntityChildren } from '../hooks/use-page-entity-children';
import { PageEntityProvider } from '../context/page-entity-context';
import { EntityProvider } from '../context/entity-context';
import { Seo } from '../elements/seo';
export var createGatsbyPageComponent = function (entityTypeName, _a) {
  var _b = _a === void 0 ? {} : _a,
    path = _b.path,
    debug = _b.debug,
    defaultValue = _b.defaultValue,
    layout = _b.layout,
    getLayout = _b.getLayout,
    _c = _b.transform,
    transform = _c === void 0 ? identity : _c;
  return function (props) {
    var ProvidedLayout = useEntityLayout(entityTypeName);
    var baseEntity = useEntity();
    // const basePageEntity = usePageEntity();
    var entity = transform(__assign(__assign(__assign({}, baseEntity), platformQueryValue(props.data, path || camelCase(entityTypeName), defaultValue)), {
      entityTypeName: entityTypeName
    }));
    // sometimes we need the full entity info for components and these can be passed here
    var pageEntityChildren = usePageEntityChildren();
    var Layout = getLayout && getLayout(entity) || layout || ProvidedLayout;
    if (debug) {
      console.log("".concat(entityTypeName, ":"), entity);
    }
    return React.createElement(PageEntityProvider, {
      value: entity
    }, React.createElement(EntityProvider, {
      value: entity
    }, React.createElement(Seo, null), React.createElement(Layout, {
      entity: entity
    }), pageEntityChildren));
  };
};